// extracted by mini-css-extract-plugin
export var bubble = "_4b-0";
export var container = "_4b-f";
export var contrastBorder = "_4b-g";
export var greyOut = "_4b-2";
export var initialsColor0 = "_4b-3";
export var initialsColor1 = "_4b-4";
export var initialsColor10 = "_4b-d";
export var initialsColor11 = "_4b-e";
export var initialsColor2 = "_4b-5";
export var initialsColor3 = "_4b-6";
export var initialsColor4 = "_4b-7";
export var initialsColor5 = "_4b-8";
export var initialsColor6 = "_4b-9";
export var initialsColor7 = "_4b-a";
export var initialsColor8 = "_4b-b";
export var initialsColor9 = "_4b-c";
export var initialsWrapper = "_4b-1";
export var large = "_4b-l";
export var medium = "_4b-k";
export var mediumSmall = "_4b-j";
export var mediumSmallMedium = "_4b-o";
export var micro = "_4b-h";
export var small = "_4b-i";
export var tiny = "_4b-n";
export var xTiny = "_4b-m";